// Salesforce コネクター API クライアント。
// OAuth 開始 / 接続状態取得 / 接続テスト / 切断 の 4 エンドポイントを薄くラップする。
// ApiClient(frontend/src/api/client.ts) に乗せることで、Authorization ヘッダ付与・
// 401/403/5xx 正規化は既存クライアントに委譲する。テスト時は apiClient をスタブに差し替える。
import type { ApiClient } from "../api/client";

export interface ConnectApiDeps {
  readonly apiClient: ApiClient;
}

export interface StartResult {
  readonly authorizeUrl: string;
}

// バックエンド runView の status と一致させる（"disconnected" が未接続。"not_connected" は送られない）。
// 組織表示名（orgName）は SP1 対象外（接続のみ）。SP2 で org クエリ後に提供する。
export interface ConnectionStatus {
  readonly status: "connected" | "expired" | "disconnected";
  readonly orgId?: string;
  readonly instanceUrl?: string;
  // connectedAt / lastTestAt はバックエンドが Date.now() で書く epoch MS（秒ではない）。
  // 表示側は new Date(connectedAt) でそのまま渡すこと（* 1000 しない）。
  readonly connectedAt?: number;
  readonly lastTestAt?: number;
}

export interface TestResult {
  readonly status: string;
}

// POST /sf/connect/start → { authorizeUrl }
// body はオプション。orgType/myDomain を渡すことでバックエンドが適切な認証URLを生成する。
export async function start(
  deps: ConnectApiDeps,
  body?: { orgType?: string; myDomain?: string },
): Promise<StartResult> {
  return deps.apiClient.post<StartResult>("/sf/connect/start", body ?? {});
}

// GET /sf/connection → ConnectionStatus
export async function getConnection(deps: ConnectApiDeps): Promise<ConnectionStatus> {
  return deps.apiClient.get<ConnectionStatus>("/sf/connection");
}

// POST /sf/connect/test → { status }
export async function test(deps: ConnectApiDeps): Promise<TestResult> {
  return deps.apiClient.post<TestResult>("/sf/connect/test", {});
}

// DELETE /sf/connection → 204 No Content
export async function disconnect(deps: ConnectApiDeps): Promise<void> {
  return deps.apiClient.del<void>("/sf/connection");
}
